import { render, staticRenderFns } from "./InvitationConfirm.vue?vue&type=template&id=5a4d1ff4&"
import script from "./InvitationConfirm.vue?vue&type=script&lang=js&"
export * from "./InvitationConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports